import { useState, useEffect, useRef} from "react";
import Route from "./Route";
import GlobalStyle from "./Globalstyle";

// const useTitle = () => {
//   const [title, setTitle] = useState("dain");
//   useEffect(() => {
//     const titleName = document.querySelector('title');
//     titleName.innerText = title;
//   }, [])


// }




function App() {
  // useTitle();
  return (
    <>
      <GlobalStyle />
      <Route />
    </>
  );
}

export default App;
